import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { devicesData } from '../mock';
import { Card, CardContent } from './ui/card';

const DeviceGallery = () => {
  const { t } = useLanguage();

  return (
    <section id="devices" className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1584515933487-779824d29309)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.devices.title}
          </h2>
          <p className="text-lg text-gray-600">
            {t.devices.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {devicesData.map((device, index) => (
            <Card 
              key={device.id}
              className="card-hover border-none shadow-lg bg-white overflow-hidden"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <CardContent className="p-0">
                <div className="h-64 bg-white flex items-center justify-center p-6 overflow-hidden rounded-t-lg">
                  <img 
                    src={device.image}
                    alt={t.devices.items[index]}
                    className="max-h-full max-w-full object-contain hover:scale-105 transition-transform duration-300"
                    style={{ borderRadius: '12px' }}
                  />
                </div>
                <div className="p-4 text-center border-t">
                  <h3 className="text-lg font-semibold" style={{ color: '#2D4A8F' }}>
                    {t.devices.items[index]}
                  </h3>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeviceGallery;